export default __webpack_public_path__ + "static/media/23M.febe4cfd.jpeg";